module.exports = __webpack_public_path__ + "img/security_shield_sso.97b4269f.svg";